import client from "./sharedoClient";
import queryString from "@/util/queryStringGenerator";

const getAll = (rootTypes, showDisabled) => client.get(`/api/sharedoTypes/tree${queryString.generate({ roots: rootTypes, showDisabledTypes: showDisabled })}`);

export default {
    getAll,
}